import { render, staticRenderFns } from "./LoginSsoCallBack.vue?vue&type=template&id=a205ed5a&"
import script from "./LoginSsoCallBack.vue?vue&type=script&lang=js&"
export * from "./LoginSsoCallBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports